module.exports = __webpack_public_path__ + "static/media/13_Wallace Law (membership)-min.33d7a88c.jpg";